import React, { useEffect, useState } from "react";
import { Share, Plus, X, MoreVertical } from "lucide-react";

const DISMISS_KEY = "hm_a2hs_dismissed";

// Friendly "Add to Home Screen" hint for new mobile players so they can play
// full-screen without the browser bar. Auto-hides on desktop, when already
// running as an installed PWA, or once dismissed.
export const HomeScreenTip = () => {
  const [platform, setPlatform] = useState(null); // 'ios' | 'android' | null
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (localStorage.getItem(DISMISS_KEY) === "1") return;
      const ua = (navigator.userAgent || navigator.vendor || "").toLowerCase();
      const isIOS = /iphone|ipad|ipod/.test(ua) ||
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1); // iPadOS
      const isAndroid = /android/.test(ua);
      const standalone = window.navigator.standalone === true ||
        window.matchMedia?.("(display-mode: standalone)").matches;
      if (standalone) return;
      if (isIOS) setPlatform("ios");
      else if (isAndroid) setPlatform("android");
      else return;
      const t = setTimeout(() => setVisible(true), 900);
      return () => clearTimeout(t);
    } catch { /* non-fatal */ }
  }, []);

  const dismiss = () => {
    setVisible(false);
    try { localStorage.setItem(DISMISS_KEY, "1"); } catch {}
  };

  if (!visible || !platform) return null;

  return (
    <div
      data-testid="home-screen-tip"
      className="fixed left-1/2 -translate-x-1/2 bottom-3 z-[10000] w-[92%] max-w-sm"
      style={{ animation: "hmTipIn 0.35s ease-out" }}
    >
      <div className="rounded-2xl border-2 border-gold bg-navy/95 backdrop-blur-md px-4 py-3 shadow-[0_10px_30px_rgba(0,0,0,0.5)] flex items-start gap-3">
        <div className="flex-1 min-w-0">
          <div className="font-bebas text-white text-white-shadow text-lg tracking-wide uppercase">
            Speel op volledig scherm 📱
          </div>
          <p className="text-cream/85 text-sm font-bold leading-snug mt-0.5">
            {platform === "ios" ? (
              <>Tik op <span className="inline-flex items-center gap-1 text-gold"><Share className="w-4 h-4" strokeWidth={2.6} /> Delen</span> → <span className="text-gold">"Zet op beginscherm"</span> om de browserbalk te verbergen.</>
            ) : (
              <>Tik op <span className="inline-flex items-center gap-1 text-gold"><MoreVertical className="w-4 h-4" strokeWidth={2.6} /> menu</span> → <span className="text-gold inline-flex items-center gap-1"><Plus className="w-4 h-4" strokeWidth={2.6} /> "Toevoegen aan startscherm"</span> om de browserbalk te verbergen.</>
            )}
          </p>
        </div>
        <button
          data-testid="home-screen-tip-dismiss"
          onClick={dismiss}
          aria-label="Sluiten"
          className="shrink-0 w-7 h-7 rounded-full bg-white/15 hover:bg-white/30 border border-white/30 flex items-center justify-center text-white transition-colors"
        >
          <X className="w-4 h-4" strokeWidth={2.6} />
        </button>
      </div>
    </div>
  );
};
